import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import * as nls from '../../../nls.js';
import { IUndoRedoService, ResourceEditStackSnapshot } from './undoRedo.js';
import { onUnexpectedError } from '../../../base/common/errors.js';
import { registerSingleton } from '../../instantiation/common/extensions.js';
import { IDialogService } from '../../dialogs/common/dialogs.js';
import Severity from '../../../base/common/severity.js';
import { Schemas } from '../../../base/common/network.js';
import { INotificationService } from '../../notification/common/notification.js';
import { Disposable, isDisposable } from '../../../base/common/lifecycle.js';
var DEBUG = false;

function getResourceLabel(resource) {
  return resource.scheme === Schemas.file ? resource.fsPath : resource.path;
}

var stackElementCounter = 0;

var ResourceStackElement = /*#__PURE__*/function () {
  function ResourceStackElement(actual, resourceLabel, strResource) {
    _classCallCheck(this, ResourceStackElement);

    this.id = ++stackElementCounter;
    this.type = 0
    /* Resource */
    ;
    this.actual = actual;
    this.label = actual.label;
    this.resourceLabel = resourceLabel;
    this.strResource = strResource;
    this.resourceLabels = [this.resourceLabel];
    this.strResources = [this.strResource];
    this.isValid = true;
  }

  _createClass(ResourceStackElement, [{
    key: "setValid",
    value: function setValid(isValid) {
      this.isValid = isValid;
    }
  }, {
    key: "toString",
    value: function toString() {
      return "[".concat(this.id, "] [").concat(this.isValid ? 'VALID' : 'INVALID', "] ").concat(this.actual);
    }
  }]);

  return ResourceStackElement;
}();

var ResourceReasonPair = function ResourceReasonPair(resourceLabel, reason) {
  _classCallCheck(this, ResourceReasonPair);

  this.resourceLabel = resourceLabel;
  this.reason = reason;
};

var RemovedResources = /*#__PURE__*/function () {
  function RemovedResources() {
    _classCallCheck(this, RemovedResources);

    this.elements = new Map();
  }

  _createClass(RemovedResources, [{
    key: "createMessage",
    value: function createMessage() {
      var externalRemoval = [];
      var noParallelUniverses = [];

      var _iterator = _createForOfIteratorHelper(this.elements),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              element = _step$value[1];

          var dest = element.reason === 0
          /* ExternalRemoval */
          ? externalRemoval : noParallelUniverses;
          dest.push(element.resourceLabel);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var messages = [];

      if (externalRemoval.length > 0) {
        messages.push(nls.localize({
          key: 'externalRemoval',
          comment: ['{0} is a list of filenames']
        }, "The following files have been closed and modified on disk: {0}.", externalRemoval.join(', ')));
      }

      if (noParallelUniverses.length > 0) {
        messages.push(nls.localize({
          key: 'noParallelUniverses',
          comment: ['{0} is a list of filenames']
        }, "The following files have been modified in an incompatible way: {0}.", noParallelUniverses.join(', ')));
      }

      return messages.join('\n');
    }
  }, {
    key: "size",
    get: function get() {
      return this.elements.size;
    }
  }, {
    key: "has",
    value: function has(strResource) {
      return this.elements.has(strResource);
    }
  }, {
    key: "set",
    value: function set(strResource, value) {
      this.elements.set(strResource, value);
    }
  }, {
    key: "delete",
    value: function _delete(strResource) {
      return this.elements.delete(strResource);
    }
  }]);

  return RemovedResources;
}();

var WorkspaceStackElement = /*#__PURE__*/function () {
  function WorkspaceStackElement(actual, resourceLabels, strResources) {
    _classCallCheck(this, WorkspaceStackElement);

    this.id = ++stackElementCounter;
    this.type = 1
    /* Workspace */
    ;
    this.actual = actual;
    this.label = actual.label;
    this.resourceLabels = resourceLabels;
    this.strResources = strResources;
    this.removedResources = null;
    this.invalidatedResources = null;
  }

  _createClass(WorkspaceStackElement, [{
    key: "canSplit",
    value: function canSplit() {
      return typeof this.actual.split === 'function';
    }
  }, {
    key: "removeResource",
    value: function removeResource(resourceLabel, strResource, reason) {
      if (!this.removedResources) {
        this.removedResources = new RemovedResources();
      }

      if (!this.removedResources.has(strResource)) {
        this.removedResources.set(strResource, new ResourceReasonPair(resourceLabel, reason));
      }
    }
  }, {
    key: "setValid",
    value: function setValid(resourceLabel, strResource, isValid) {
      if (isValid) {
        if (this.invalidatedResources) {
          this.invalidatedResources.delete(strResource);

          if (this.invalidatedResources.size === 0) {
            this.invalidatedResources = null;
          }
        }
      } else {
        if (!this.invalidatedResources) {
          this.invalidatedResources = new RemovedResources();
        }

        if (!this.invalidatedResources.has(strResource)) {
          this.invalidatedResources.set(strResource, new ResourceReasonPair(resourceLabel, 0
          /* ExternalRemoval */
          ));
        }
      }
    }
  }, {
    key: "toString",
    value: function toString() {
      return "[".concat(this.id, "] [").concat(this.invalidatedResources ? 'INVALID' : 'VALID', "] ").concat(this.actual);
    }
  }]);

  return WorkspaceStackElement;
}();

var ResourceEditStack = /*#__PURE__*/function () {
  function ResourceEditStack(resourceLabel, strResource) {
    _classCallCheck(this, ResourceEditStack);

    this.resourceLabel = resourceLabel;
    this.strResource = strResource;
    this._past = [];
    this._future = [];
    this.locked = false;
    this.versionId = 1;
  }

  _createClass(ResourceEditStack, [{
    key: "dispose",
    value: function dispose() {
      var _iterator2 = _createForOfIteratorHelper(this._past),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var element = _step2.value;

          if (element.type === 1
          /* Workspace */
          ) {
            element.removeResource(this.resourceLabel, this.strResource, 0
            /* ExternalRemoval */
            );
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(this._future),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _element2 = _step3.value;

          if (_element2.type === 1
          /* Workspace */
          ) {
            _element2.removeResource(this.resourceLabel, this.strResource, 0
            /* ExternalRemoval */
            );
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      this.versionId++;
    }
  }, {
    key: "toString",
    value: function toString() {
      var result = [];
      result.push("* ".concat(this.strResource, ":"));

      for (var i = 0; i < this._past.length; i++) {
        result.push("   * [UNDO] ".concat(this._past[i]));
      }

      for (var _i = this._future.length - 1; _i >= 0; _i--) {
        result.push("   * [REDO] ".concat(this._future[_i]));
      }

      return result.join('\n');
    }
  }, {
    key: "flushAllElements",
    value: function flushAllElements() {
      this._past = [];
      this._future = [];
      this.versionId++;
    }
  }, {
    key: "_setElementValidFlag",
    value: function _setElementValidFlag(element, isValid) {
      if (element.type === 1
      /* Workspace */
      ) {
        element.setValid(this.resourceLabel, this.strResource, isValid);
      } else {
        element.setValid(isValid);
      }
    }
  }, {
    key: "setElementsValidFlag",
    value: function setElementsValidFlag(isValid, filter) {
      var _iterator4 = _createForOfIteratorHelper(this._past),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var element = _step4.value;

          if (filter(element.actual)) {
            this._setElementValidFlag(element, isValid);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      var _iterator5 = _createForOfIteratorHelper(this._future),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _element3 = _step5.value;

          if (filter(_element3.actual)) {
            this._setElementValidFlag(_element3, isValid);
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "pushElement",
    value: function pushElement(element) {
      // remove the future
      var _iterator6 = _createForOfIteratorHelper(this._future),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var futureElement = _step6.value;

          if (futureElement.type === 1
          /* Workspace */
          ) {
            futureElement.removeResource(this.resourceLabel, this.strResource, 1
            /* NoParallelUniverses */
            );
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      this._future = [];

      if (this._past.length > 0) {
        var lastElement = this._past[this._past.length - 1];

        if (lastElement.type === 0
        /* Resource */
        && !lastElement.isValid) {
          // clear undo stack
          this._past = [];
        }
      }

      this._past.push(element);

      this.versionId++;
    }
  }, {
    key: "createSnapshot",
    value: function createSnapshot(resource) {
      var elements = [];

      for (var i = 0, len = this._past.length; i < len; i++) {
        elements.push(this._past[i].id);
      }

      for (var _i2 = this._future.length - 1; _i2 >= 0; _i2--) {
        elements.push(this._future[_i2].id);
      }

      return new ResourceEditStackSnapshot(resource, elements);
    }
  }, {
    key: "restoreSnapshot",
    value: function restoreSnapshot(snapshot) {
      var snapshotLength = snapshot.elements.length;
      var isOK = true;
      var snapshotIndex = 0;
      var removePastAfter = -1;

      for (var i = 0, len = this._past.length; i < len; i++, snapshotIndex++) {
        var element = this._past[i];

        if (isOK && (snapshotIndex >= snapshotLength || element.id !== snapshot.elements[snapshotIndex])) {
          isOK = false;
          removePastAfter = 0;
        }

        if (!isOK && element.type === 1
        /* Workspace */
        ) {
          element.removeResource(this.resourceLabel, this.strResource, 0
          /* ExternalRemoval */
          );
        }
      }

      var removeFutureBefore = -1;

      for (var _i3 = this._future.length - 1; _i3 >= 0; _i3--, snapshotIndex++) {
        var _element4 = this._future[_i3];

        if (isOK && (snapshotIndex >= snapshotLength || _element4.id !== snapshot.elements[snapshotIndex])) {
          isOK = false;
          removeFutureBefore = _i3;
        }

        if (!isOK && _element4.type === 1
        /* Workspace */
        ) {
          _element4.removeResource(this.resourceLabel, this.strResource, 0
          /* ExternalRemoval */
          );
        }
      }

      if (removePastAfter !== -1) {
        this._past = this._past.slice(0, removePastAfter);
      }

      if (removeFutureBefore !== -1) {
        this._future = this._future.slice(removeFutureBefore + 1);
      }

      this.versionId++;
    }
  }, {
    key: "getElements",
    value: function getElements() {
      var past = [];
      var future = [];

      var _iterator7 = _createForOfIteratorHelper(this._past),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var element = _step7.value;
          past.push(element.actual);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      var _iterator8 = _createForOfIteratorHelper(this._future),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _element5 = _step8.value;
          future.push(_element5.actual);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      return {
        past: past,
        future: future
      };
    }
  }, {
    key: "getClosestPastElement",
    value: function getClosestPastElement() {
      if (this._past.length === 0) {
        return null;
      }

      return this._past[this._past.length - 1];
    }
  }, {
    key: "getClosestFutureElement",
    value: function getClosestFutureElement() {
      if (this._future.length === 0) {
        return null;
      }

      return this._future[this._future.length - 1];
    }
  }, {
    key: "hasPastElements",
    value: function hasPastElements() {
      return this._past.length > 0;
    }
  }, {
    key: "hasFutureElements",
    value: function hasFutureElements() {
      return this._future.length > 0;
    }
  }, {
    key: "splitPastWorkspaceElement",
    value: function splitPastWorkspaceElement(toRemove, individualMap) {
      for (var j = this._past.length - 1; j >= 0; j--) {
        if (this._past[j] === toRemove) {
          if (individualMap.has(this.strResource)) {
            // gets replaced
            this._past[j] = individualMap.get(this.strResource);
          } else {
            // gets deleted
            this._past.splice(j, 1);
          }

          break;
        }
      }

      this.versionId++;
    }
  }, {
    key: "splitFutureWorkspaceElement",
    value: function splitFutureWorkspaceElement(toRemove, individualMap) {
      for (var j = this._future.length - 1; j >= 0; j--) {
        if (this._future[j] === toRemove) {
          if (individualMap.has(this.strResource)) {
            // gets replaced
            this._future[j] = individualMap.get(this.strResource);
          } else {
            // gets deleted
            this._future.splice(j, 1);
          }

          break;
        }
      }

      this.versionId++;
    }
  }, {
    key: "moveBackward",
    value: function moveBackward(element) {
      this._past.pop();

      this._future.push(element);

      this.versionId++;
    }
  }, {
    key: "moveForward",
    value: function moveForward(element) {
      this._future.pop();

      this._past.push(element);

      this.versionId++;
    }
  }]);

  return ResourceEditStack;
}();

var EditStackSnapshot = /*#__PURE__*/function () {
  function EditStackSnapshot(editStacks) {
    _classCallCheck(this, EditStackSnapshot);

    this.editStacks = editStacks;
    this._versionIds = [];

    for (var i = 0, len = this.editStacks.length; i < len; i++) {
      this._versionIds[i] = this.editStacks[i].versionId;
    }
  }

  _createClass(EditStackSnapshot, [{
    key: "isValid",
    value: function isValid() {
      for (var i = 0, len = this.editStacks.length; i < len; i++) {
        if (this._versionIds[i] !== this.editStacks[i].versionId) {
          return false;
        }
      }

      return true;
    }
  }]);

  return EditStackSnapshot;
}();

var missingEditStack = new ResourceEditStack('', '');
missingEditStack.locked = true;

var UndoRedoService = /*#__PURE__*/function () {
  function UndoRedoService(_dialogService, _notificationService) {
    _classCallCheck(this, UndoRedoService);

    this._dialogService = _dialogService;
    this._notificationService = _notificationService;
    this._editStacks = new Map();
    this._uriComparisonKeyComputers = [];
  }

  _createClass(UndoRedoService, [{
    key: "getUriComparisonKey",
    value: function getUriComparisonKey(resource) {
      var _iterator9 = _createForOfIteratorHelper(this._uriComparisonKeyComputers),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var uriComparisonKeyComputer = _step9.value;

          if (uriComparisonKeyComputer[0] === resource.scheme) {
            return uriComparisonKeyComputer[1].getComparisonKey(resource);
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      return resource.toString();
    }
  }, {
    key: "_print",
    value: function _print(label) {
      console.log("------------------------------------");
      console.log("AFTER ".concat(label, ": "));
      var str = [];

      var _iterator10 = _createForOfIteratorHelper(this._editStacks),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var element = _step10.value;
          str.push(element[1].toString());
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }

      console.log(str.join('\n'));
    }
  }, {
    key: "pushElement",
    value: function pushElement(element) {
      if (element.type === 0
      /* Resource */
      ) {
        var resourceLabel = getResourceLabel(element.resource);
        var strResource = this.getUriComparisonKey(element.resource);

        this._pushElement(new ResourceStackElement(element, resourceLabel, strResource));
      } else {
        var seen = new Set();
        var resourceLabels = [];
        var strResources = [];

        var _iterator11 = _createForOfIteratorHelper(element.resources),
            _step11;

        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var resource = _step11.value;

            var _resourceLabel = getResourceLabel(resource);

            var _strResource = this.getUriComparisonKey(resource);

            if (seen.has(_strResource)) {
              continue;
            }

            seen.add(_strResource);
            resourceLabels.push(_resourceLabel);
            strResources.push(_strResource);
          }
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }

        if (resourceLabels.length === 1) {
          this._pushElement(new ResourceStackElement(element, resourceLabels[0], strResources[0]));
        } else {
          this._pushElement(new WorkspaceStackElement(element, resourceLabels, strResources));
        }
      }

      if (DEBUG) {
        this._print('pushElement');
      }
    }
  }, {
    key: "_pushElement",
    value: function _pushElement(element) {
      for (var i = 0, len = element.strResources.length; i < len; i++) {
        var resourceLabel = element.resourceLabels[i];
        var strResource = element.strResources[i];
        var editStack = void 0;

        if (this._editStacks.has(strResource)) {
          editStack = this._editStacks.get(strResource);
        } else {
          editStack = new ResourceEditStack(resourceLabel, strResource);

          this._editStacks.set(strResource, editStack);
        }

        editStack.pushElement(element);
      }
    }
  }, {
    key: "getLastElement",
    value: function getLastElement(resource) {
      var strResource = this.getUriComparisonKey(resource);

      if (this._editStacks.has(strResource)) {
        var editStack = this._editStacks.get(strResource);

        if (editStack.hasFutureElements()) {
          return null;
        }

        var closestPastElement = editStack.getClosestPastElement();
        return closestPastElement ? closestPastElement.actual : null;
      }

      return null;
    }
  }, {
    key: "_splitPastWorkspaceElement",
    value: function _splitPastWorkspaceElement(toRemove, ignoreResources) {
      var individualArr = toRemove.actual.split();
      var individualMap = new Map();

      var _iterator12 = _createForOfIteratorHelper(individualArr),
          _step12;

      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var _element = _step12.value;
          var resourceLabel = getResourceLabel(_element.resource);
          var strResource = this.getUriComparisonKey(_element.resource);
          var element = new ResourceStackElement(_element, resourceLabel, strResource);
          individualMap.set(element.strResource, element);
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }

      var _iterator13 = _createForOfIteratorHelper(toRemove.strResources),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var _strResource2 = _step13.value;

          if (ignoreResources && ignoreResources.has(_strResource2)) {
            continue;
          }

          var editStack = this._editStacks.get(_strResource2);

          editStack.splitPastWorkspaceElement(toRemove, individualMap);
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
    }
  }, {
    key: "_splitFutureWorkspaceElement",
    value: function _splitFutureWorkspaceElement(toRemove, ignoreResources) {
      var individualArr = toRemove.actual.split();
      var individualMap = new Map();

      var _iterator14 = _createForOfIteratorHelper(individualArr),
          _step14;

      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var _element = _step14.value;
          var resourceLabel = getResourceLabel(_element.resource);
          var strResource = this.getUriComparisonKey(_element.resource);
          var element = new ResourceStackElement(_element, resourceLabel, strResource);
          individualMap.set(element.strResource, element);
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }

      var _iterator15 = _createForOfIteratorHelper(toRemove.strResources),
          _step15;

      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var _strResource3 = _step15.value;

          if (ignoreResources && ignoreResources.has(_strResource3)) {
            continue;
          }

          var editStack = this._editStacks.get(_strResource3);

          editStack.splitFutureWorkspaceElement(toRemove, individualMap);
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
    }
  }, {
    key: "removeElements",
    value: function removeElements(resource) {
      var strResource = typeof resource === 'string' ? resource : this.getUriComparisonKey(resource);

      if (this._editStacks.has(strResource)) {
        var editStack = this._editStacks.get(strResource);

        editStack.dispose();

        this._editStacks.delete(strResource);
      }

      if (DEBUG) {
        this._print('removeElements');
      }
    }
  }, {
    key: "setElementsValidFlag",
    value: function setElementsValidFlag(resource, isValid, filter) {
      var strResource = this.getUriComparisonKey(resource);

      if (this._editStacks.has(strResource)) {
        var editStack = this._editStacks.get(strResource);

        editStack.setElementsValidFlag(isValid, filter);
      }

      if (DEBUG) {
        this._print('setElementsValidFlag');
      }
    }
  }, {
    key: "createSnapshot",
    value: function createSnapshot(resource) {
      var strResource = this.getUriComparisonKey(resource);

      if (this._editStacks.has(strResource)) {
        var editStack = this._editStacks.get(strResource);

        return editStack.createSnapshot(resource);
      }

      return new ResourceEditStackSnapshot(resource, []);
    }
  }, {
    key: "restoreSnapshot",
    value: function restoreSnapshot(snapshot) {
      var strResource = this.getUriComparisonKey(snapshot.resource);

      if (this._editStacks.has(strResource)) {
        var editStack = this._editStacks.get(strResource);

        editStack.restoreSnapshot(snapshot);

        if (!editStack.hasPastElements() && !editStack.hasFutureElements()) {
          // the edit stack is now empty, just remove it entirely
          editStack.dispose();

          this._editStacks.delete(strResource);
        }
      }

      if (DEBUG) {
        this._print('restoreSnapshot');
      }
    }
  }, {
    key: "getElements",
    value: function getElements(resource) {
      var strResource = this.getUriComparisonKey(resource);

      if (this._editStacks.has(strResource)) {
        var editStack = this._editStacks.get(strResource);

        return editStack.getElements();
      }

      return {
        past: [],
        future: []
      };
    }
  }, {
    key: "canUndo",
    value: function canUndo(resource) {
      var strResource = this.getUriComparisonKey(resource);

      if (this._editStacks.has(strResource)) {
        var editStack = this._editStacks.get(strResource);

        return editStack.hasPastElements();
      }

      return false;
    }
  }, {
    key: "_onError",
    value: function _onError(err, element) {
      onUnexpectedError(err); // An error occured while undoing or redoing => drop the undo/redo stack for all affected resources

      var _iterator16 = _createForOfIteratorHelper(element.strResources),
          _step16;

      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var strResource = _step16.value;
          this.removeElements(strResource);
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }

      this._notificationService.error(err);
    }
  }, {
    key: "_acquireLocks",
    value: function _acquireLocks(editStackSnapshot) {
      // first, check if all locks can be acquired
      var _iterator17 = _createForOfIteratorHelper(editStackSnapshot.editStacks),
          _step17;

      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var editStack = _step17.value;

          if (editStack.locked) {
            throw new Error('Cannot acquire edit stack lock');
          }
        } // can acquire all locks

      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }

      var _iterator18 = _createForOfIteratorHelper(editStackSnapshot.editStacks),
          _step18;

      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var _editStack = _step18.value;
          _editStack.locked = true;
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }

      return function () {
        // release all locks
        var _iterator19 = _createForOfIteratorHelper(editStackSnapshot.editStacks),
            _step19;

        try {
          for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
            var editStack = _step19.value;
            editStack.locked = false;
          }
        } catch (err) {
          _iterator19.e(err);
        } finally {
          _iterator19.f();
        }
      };
    }
  }, {
    key: "_safeInvokeWithLocks",
    value: function _safeInvokeWithLocks(element, invoke, editStackSnapshot) {
      var _this = this;

      var cleanup = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Disposable.None;

      var releaseLocks = this._acquireLocks(editStackSnapshot);

      var result;

      try {
        result = invoke();
      } catch (err) {
        releaseLocks();
        cleanup.dispose();
        return this._onError(err, element);
      }

      if (result) {
        // result is Promise<void>
        return result.then(function () {
          releaseLocks();
          cleanup.dispose();
        }, function (err) {
          releaseLocks();
          cleanup.dispose();
          return _this._onError(err, element);
        });
      } else {
        // result is void
        releaseLocks();
        cleanup.dispose();
      }
    }
  }, {
    key: "_invokeWorkspacePrepare",
    value: function _invokeWorkspacePrepare(element) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof element.actual.prepareUndoRedo === 'undefined')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", Disposable.None);

              case 2:
                result = element.actual.prepareUndoRedo();

                if (!(typeof result === 'undefined')) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", Disposable.None);

              case 5:
                return _context.abrupt("return", result);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }, {
    key: "_invokeResourcePrepare",
    value: function _invokeResourcePrepare(element, callback) {
      if (element.actual.type !== 1
      /* Workspace */
      || typeof element.actual.prepareUndoRedo === 'undefined') {
        // no preparation needed
        callback(Disposable.None);
        return;
      }

      var r = element.actual.prepareUndoRedo();

      if (!r) {
        // nothing to clean up
        callback(Disposable.None);
        return;
      }

      if (isDisposable(r)) {
        callback(r);
        return;
      }

      return r.then(function (disposable) {
        callback(disposable);
      });
    }
  }, {
    key: "_getAffectedEditStacks",
    value: function _getAffectedEditStacks(element) {
      var affectedEditStacks = [];

      var _iterator20 = _createForOfIteratorHelper(element.strResources),
          _step20;

      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var strResource = _step20.value;
          affectedEditStacks.push(this._editStacks.get(strResource) || missingEditStack);
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }

      return new EditStackSnapshot(affectedEditStacks);
    }
  }, {
    key: "_tryToSplitAndUndo",
    value: function _tryToSplitAndUndo(strResource, element, ignoreResources, message) {
      if (element.canSplit()) {
        this._splitPastWorkspaceElement(element, ignoreResources);

        this._notificationService.info(message);

        return new WorkspaceVerificationError(this.undo(strResource));
      } else {
        // Cannot safely split this workspace element => flush all undo/redo stacks
        var _iterator21 = _createForOfIteratorHelper(element.strResources),
            _step21;

        try {
          for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
            var _strResource4 = _step21.value;
            this.removeElements(_strResource4);
          }
        } catch (err) {
          _iterator21.e(err);
        } finally {
          _iterator21.f();
        }

        this._notificationService.info(message);

        return new WorkspaceVerificationError();
      }
    }
  }, {
    key: "_checkWorkspaceUndo",
    value: function _checkWorkspaceUndo(strResource, element, editStackSnapshot, checkInvalidatedResources) {
      if (element.removedResources) {
        return this._tryToSplitAndUndo(strResource, element, element.removedResources, nls.localize({
          key: 'cannotWorkspaceUndo',
          comment: ['{0} is a label for an operation. {1} is another message.']
        }, "Could not undo '{0}' across all files. {1}", element.label, element.removedResources.createMessage()));
      }

      if (checkInvalidatedResources && element.invalidatedResources) {
        return this._tryToSplitAndUndo(strResource, element, element.invalidatedResources, nls.localize({
          key: 'cannotWorkspaceUndo',
          comment: ['{0} is a label for an operation. {1} is another message.']
        }, "Could not undo '{0}' across all files. {1}", element.label, element.invalidatedResources.createMessage()));
      } // this must be the last past element in all the impacted resources!


      var cannotUndoDueToResources = [];

      var _iterator22 = _createForOfIteratorHelper(editStackSnapshot.editStacks),
          _step22;

      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var editStack = _step22.value;

          if (editStack.getClosestPastElement() !== element) {
            cannotUndoDueToResources.push(editStack.resourceLabel);
          }
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }

      if (cannotUndoDueToResources.length > 0) {
        return this._tryToSplitAndUndo(strResource, element, null, nls.localize({
          key: 'cannotWorkspaceUndoDueToChanges',
          comment: ['{0} is a label for an operation. {1} is a list of filenames.']
        }, "Could not undo '{0}' across all files because changes were made to {1}", element.label, cannotUndoDueToResources.join(', ')));
      }

      var cannotLockDueToResources = [];

      var _iterator23 = _createForOfIteratorHelper(editStackSnapshot.editStacks),
          _step23;

      try {
        for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
          var _editStack2 = _step23.value;

          if (_editStack2.locked) {
            cannotLockDueToResources.push(_editStack2.resourceLabel);
          }
        }
      } catch (err) {
        _iterator23.e(err);
      } finally {
        _iterator23.f();
      }

      if (cannotLockDueToResources.length > 0) {
        return this._tryToSplitAndUndo(strResource, element, null, nls.localize({
          key: 'cannotWorkspaceUndoDueToInProgressUndoRedo',
          comment: ['{0} is a label for an operation. {1} is a list of filenames.']
        }, "Could not undo '{0}' across all files because there is already an undo or redo operation running on {1}", element.label, cannotLockDueToResources.join(', ')));
      } // check if new stack elements were added in the meantime...


      if (!editStackSnapshot.isValid()) {
        return this._tryToSplitAndUndo(strResource, element, null, nls.localize({
          key: 'cannotWorkspaceUndoDueToInMeantimeUndoRedo',
          comment: ['{0} is a label for an operation. {1} is a list of filenames.']
        }, "Could not undo '{0}' across all files because an undo or redo operation occurred in the meantime", element.label));
      }

      return null;
    }
  }, {
    key: "_workspaceUndo",
    value: function _workspaceUndo(strResource, element) {
      var affectedEditStacks = this._getAffectedEditStacks(element);

      var verificationError = this._checkWorkspaceUndo(strResource, element, affectedEditStacks,
      /*invalidated resources will be checked after the prepare call*/
      false);

      if (verificationError) {
        return verificationError.returnValue;
      }

      return this._confirmAndExecuteWorkspaceUndo(strResource, element, affectedEditStacks);
    }
  }, {
    key: "_confirmAndExecuteWorkspaceUndo",
    value: function _confirmAndExecuteWorkspaceUndo(strResource, element, editStackSnapshot) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var result, verificationError1, cleanup, verificationError2, _iterator24, _step24, editStack;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!element.canSplit()) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 3;
                return this._dialogService.show(Severity.Info, nls.localize('confirmWorkspace', "Would you like to undo '{0}' across all files?", element.label), [nls.localize({
                  key: 'ok',
                  comment: ['{0} denotes a number that is > 1']
                }, "Undo in {0} Files", editStackSnapshot.editStacks.length), nls.localize('nok', "Undo this File"), nls.localize('cancel', "Cancel")], {
                  cancelId: 2
                });

              case 3:
                result = _context2.sent;

                if (!(result.choice === 2)) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return");

              case 6:
                if (!(result.choice === 1)) {
                  _context2.next = 9;
                  break;
                }

                // choice: undo this file
                this._splitPastWorkspaceElement(element, null);

                return _context2.abrupt("return", this.undo(strResource));

              case 9:
                // choice: undo in all files
                // At this point, it is possible that the element has been made invalid in the meantime (due to the confirmation await)
                verificationError1 = this._checkWorkspaceUndo(strResource, element, editStackSnapshot,
                /*invalidated resources will be checked after the prepare call*/
                false);

                if (!verificationError1) {
                  _context2.next = 12;
                  break;
                }

                return _context2.abrupt("return", verificationError1.returnValue);

              case 12:
                _context2.prev = 12;
                _context2.next = 15;
                return this._invokeWorkspacePrepare(element);

              case 15:
                cleanup = _context2.sent;
                _context2.next = 21;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](12);
                return _context2.abrupt("return", this._onError(_context2.t0, element));

              case 21:
                // At this point, it is possible that the element has been made invalid in the meantime (due to the prepare await)
                verificationError2 = this._checkWorkspaceUndo(strResource, element, editStackSnapshot,
                /*now also check that there are no more invalidated resources*/
                true);

                if (!verificationError2) {
                  _context2.next = 25;
                  break;
                }

                cleanup.dispose();
                return _context2.abrupt("return", verificationError2.returnValue);

              case 25:
                _iterator24 = _createForOfIteratorHelper(editStackSnapshot.editStacks);

                try {
                  for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
                    editStack = _step24.value;
                    editStack.moveBackward(element);
                  }
                } catch (err) {
                  _iterator24.e(err);
                } finally {
                  _iterator24.f();
                }

                return _context2.abrupt("return", this._safeInvokeWithLocks(element, function () {
                  return element.actual.undo();
                }, editStackSnapshot, cleanup));

              case 28:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[12, 18]]);
      }));
    }
  }, {
    key: "_resourceUndo",
    value: function _resourceUndo(editStack, element) {
      var _this2 = this;

      if (!element.isValid) {
        // invalid element => immediately flush edit stack!
        editStack.flushAllElements();
        return;
      }

      if (editStack.locked) {
        var message = nls.localize({
          key: 'cannotResourceUndoDueToInProgressUndoRedo',
          comment: ['{0} is a label for an operation.']
        }, "Could not undo '{0}' because there is already an undo or redo operation running.", element.label);

        this._notificationService.info(message);

        return;
      }

      return this._invokeResourcePrepare(element, function (cleanup) {
        editStack.moveBackward(element);
        return _this2._safeInvokeWithLocks(element, function () {
          return element.actual.undo();
        }, new EditStackSnapshot([editStack]), cleanup);
      });
    }
  }, {
    key: "undo",
    value: function undo(resource) {
      var strResource = typeof resource === 'string' ? resource : this.getUriComparisonKey(resource);

      if (!this._editStacks.has(strResource)) {
        return;
      }

      var editStack = this._editStacks.get(strResource);

      var element = editStack.getClosestPastElement();

      if (!element) {
        return;
      }

      try {
        if (element.type === 1
        /* Workspace */
        ) {
          return this._workspaceUndo(strResource, element);
        } else {
          return this._resourceUndo(editStack, element);
        }
      } finally {
        if (DEBUG) {
          this._print('undo');
        }
      }
    }
  }, {
    key: "canRedo",
    value: function canRedo(resource) {
      var strResource = this.getUriComparisonKey(resource);

      if (this._editStacks.has(strResource)) {
        var editStack = this._editStacks.get(strResource);

        return editStack.hasFutureElements();
      }

      return false;
    }
  }, {
    key: "_tryToSplitAndRedo",
    value: function _tryToSplitAndRedo(strResource, element, ignoreResources, message) {
      if (element.canSplit()) {
        this._splitFutureWorkspaceElement(element, ignoreResources);

        this._notificationService.info(message);

        return new WorkspaceVerificationError(this.redo(strResource));
      } else {
        // Cannot safely split this workspace element => flush all undo/redo stacks
        var _iterator25 = _createForOfIteratorHelper(element.strResources),
            _step25;

        try {
          for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
            var _strResource5 = _step25.value;
            this.removeElements(_strResource5);
          }
        } catch (err) {
          _iterator25.e(err);
        } finally {
          _iterator25.f();
        }

        this._notificationService.info(message);

        return new WorkspaceVerificationError();
      }
    }
  }, {
    key: "_checkWorkspaceRedo",
    value: function _checkWorkspaceRedo(strResource, element, editStackSnapshot, checkInvalidatedResources) {
      if (element.removedResources) {
        return this._tryToSplitAndRedo(strResource, element, element.removedResources, nls.localize({
          key: 'cannotWorkspaceRedo',
          comment: ['{0} is a label for an operation. {1} is another message.']
        }, "Could not redo '{0}' across all files. {1}", element.label, element.removedResources.createMessage()));
      }

      if (checkInvalidatedResources && element.invalidatedResources) {
        return this._tryToSplitAndRedo(strResource, element, element.invalidatedResources, nls.localize({
          key: 'cannotWorkspaceRedo',
          comment: ['{0} is a label for an operation. {1} is another message.']
        }, "Could not redo '{0}' across all files. {1}", element.label, element.invalidatedResources.createMessage()));
      } // this must be the last future element in all the impacted resources!


      var cannotRedoDueToResources = [];

      var _iterator26 = _createForOfIteratorHelper(editStackSnapshot.editStacks),
          _step26;

      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var editStack = _step26.value;

          if (editStack.getClosestFutureElement() !== element) {
            cannotRedoDueToResources.push(editStack.resourceLabel);
          }
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }

      if (cannotRedoDueToResources.length > 0) {
        return this._tryToSplitAndRedo(strResource, element, null, nls.localize({
          key: 'cannotWorkspaceRedoDueToChanges',
          comment: ['{0} is a label for an operation. {1} is a list of filenames.']
        }, "Could not redo '{0}' across all files because changes were made to {1}", element.label, cannotRedoDueToResources.join(', ')));
      }

      var cannotLockDueToResources = [];

      var _iterator27 = _createForOfIteratorHelper(editStackSnapshot.editStacks),
          _step27;

      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var _editStack3 = _step27.value;

          if (_editStack3.locked) {
            cannotLockDueToResources.push(_editStack3.resourceLabel);
          }
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }

      if (cannotLockDueToResources.length > 0) {
        return this._tryToSplitAndRedo(strResource, element, null, nls.localize({
          key: 'cannotWorkspaceRedoDueToInProgressUndoRedo',
          comment: ['{0} is a label for an operation. {1} is a list of filenames.']
        }, "Could not redo '{0}' across all files because there is already an undo or redo operation running on {1}", element.label, cannotLockDueToResources.join(', ')));
      } // check if new stack elements were added in the meantime...


      if (!editStackSnapshot.isValid()) {
        return this._tryToSplitAndRedo(strResource, element, null, nls.localize({
          key: 'cannotWorkspaceRedoDueToInMeantimeUndoRedo',
          comment: ['{0} is a label for an operation. {1} is a list of filenames.']
        }, "Could not redo '{0}' across all files because an undo or redo operation occurred in the meantime", element.label));
      }

      return null;
    }
  }, {
    key: "_workspaceRedo",
    value: function _workspaceRedo(strResource, element) {
      var affectedEditStacks = this._getAffectedEditStacks(element);

      var verificationError = this._checkWorkspaceRedo(strResource, element, affectedEditStacks,
      /*invalidated resources will be checked after the prepare call*/
      false);

      if (verificationError) {
        return verificationError.returnValue;
      }

      return this._executeWorkspaceRedo(strResource, element, affectedEditStacks);
    }
  }, {
    key: "_executeWorkspaceRedo",
    value: function _executeWorkspaceRedo(strResource, element, editStackSnapshot) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var cleanup, verificationError, _iterator28, _step28, editStack;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this._invokeWorkspacePrepare(element);

              case 3:
                cleanup = _context3.sent;
                _context3.next = 9;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", this._onError(_context3.t0, element));

              case 9:
                // At this point, it is possible that the element has been made invalid in the meantime (due to the prepare await)
                verificationError = this._checkWorkspaceRedo(strResource, element, editStackSnapshot,
                /*now also check that there are no more invalidated resources*/
                true);

                if (!verificationError) {
                  _context3.next = 13;
                  break;
                }

                cleanup.dispose();
                return _context3.abrupt("return", verificationError.returnValue);

              case 13:
                _iterator28 = _createForOfIteratorHelper(editStackSnapshot.editStacks);

                try {
                  for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
                    editStack = _step28.value;
                    editStack.moveForward(element);
                  }
                } catch (err) {
                  _iterator28.e(err);
                } finally {
                  _iterator28.f();
                }

                return _context3.abrupt("return", this._safeInvokeWithLocks(element, function () {
                  return element.actual.redo();
                }, editStackSnapshot, cleanup));

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 6]]);
      }));
    }
  }, {
    key: "_resourceRedo",
    value: function _resourceRedo(editStack, element) {
      var _this3 = this;

      if (!element.isValid) {
        // invalid element => immediately flush edit stack!
        editStack.flushAllElements();
        return;
      }

      if (editStack.locked) {
        var message = nls.localize({
          key: 'cannotResourceRedoDueToInProgressUndoRedo',
          comment: ['{0} is a label for an operation.']
        }, "Could not redo '{0}' because there is already an undo or redo operation running.", element.label);

        this._notificationService.info(message);

        return;
      }

      return this._invokeResourcePrepare(element, function (cleanup) {
        editStack.moveForward(element);
        return _this3._safeInvokeWithLocks(element, function () {
          return element.actual.redo();
        }, new EditStackSnapshot([editStack]), cleanup);
      });
    }
  }, {
    key: "redo",
    value: function redo(resource) {
      var strResource = typeof resource === 'string' ? resource : this.getUriComparisonKey(resource);

      if (!this._editStacks.has(strResource)) {
        return;
      }

      var editStack = this._editStacks.get(strResource);

      var element = editStack.getClosestFutureElement();

      if (!element) {
        return;
      }

      try {
        if (element.type === 1
        /* Workspace */
        ) {
          return this._workspaceRedo(strResource, element);
        } else {
          return this._resourceRedo(editStack, element);
        }
      } finally {
        if (DEBUG) {
          this._print('redo');
        }
      }
    }
  }]);

  return UndoRedoService;
}();

UndoRedoService = __decorate([__param(0, IDialogService), __param(1, INotificationService)], UndoRedoService);
export { UndoRedoService };

var WorkspaceVerificationError = function WorkspaceVerificationError(returnValue) {
  _classCallCheck(this, WorkspaceVerificationError);

  this.returnValue = returnValue;
};

registerSingleton(IUndoRedoService, UndoRedoService);